import React from 'react'
import { Link } from "gatsby"
import {
  Container,
  Row,
  Col,
  Button,
} from 'reactstrap';
import Gadget from '../Gadget';
import labels from './const';
import useLabels from '../../utils/useLabels';

import * as s from './style.module.css';
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { LazyLoadImage } from "react-lazy-load-image-component"

export default function Workshops({ lang }) {
  const t = useLabels(labels, lang);

  return (
    <div id="warsztaty" className={s.root}>
      <Container className={s.container}>
        <div className={s.header}>
          <h2>{t.title}</h2>
          <img
            className={s.line}
            src={require("../Text/icons/line.svg").default}
          />
        </div>
        <Row className="align-items-top">
          {t.workshops.map((workshop) => (
            <div>
              <Workshop {...workshop} />

              {/* <Link to={`/workshops#${encodeURIComponent(workshop.id)}`}><Button color="primary" className="mb-5" dangerouslySetInnerHTML={{ __html: t.button }}></Button></Link> */}

            </div>
          ))}
        </Row>
      </Container>
      <div className={s.gadgetPosition}>
        <Gadget />
      </div>
    </div >
  )
}


export function Workshop({ id, name, title, image, workshop, description, mentorId, linkedin, date, secondTutor }) {

  let exists = false;

  let mentorsLink = "javascript:;";
  if (mentorId.length > 0) {
    mentorsLink = '/mentors#' + encodeURIComponent(mentorId);
  }

  if (secondTutor !== null && secondTutor !== undefined) {
    exists = true;
  }

  let hideLinkedIn = false;

  if (id === "joga") {
    hideLinkedIn = true;
    mentorsLink = "https://www.facebook.com/kingaariiyoga";
  }



  return (
    <div className={s.workshop} >
      <h4 className={s.workshopTitle}>{workshop}</h4>
      {date && <strong className={s.date} dangerouslySetInnerHTML={{ __html: date }}
      />}

      <div className="d-flex flex-row align-items-center mt-4">
        <div className={s.imageWrapper}>
          <div className={s.circle} />
          {<AnchorLink to={mentorsLink}>
            {/*<MentorImage filename={image} />*/}
            <LazyLoadImage effect="blur" alt="mentor zdjecie" src={image} />
          </AnchorLink>}
          {!hideLinkedIn &&
            <a href={linkedin} target="_blank">
              <div className={s.linkedin}>
                <img alt="logo social mediów mentora" src={require('../Mentors/images/linkedin.svg').default} />
              </div>
            </a>}
        </div>
        <div className="d-flex flex-column justify-content-center">
          <div className={s.name}>
            {name}
          </div>
          <div className={s.title}>
            {title}
          </div>
        </div>

      </div>

      {exists &&

        <div className="d-flex flex-row align-items-center mt-4">
          <div className={s.imageWrapper}>
            <div className={s.circle} />
            {<AnchorLink to={mentorsLink}>
              {/*<MentorImage filename={secondTutor.image} />*/}
              <LazyLoadImage effect="blur" alt="mentor zdjecie" src={image} />
            </AnchorLink>}
            <a href={secondTutor.linkedin} target="_blank">
              <div className={s.linkedin}>
                <img alt="logo social mediów mentora" src={require('../Mentors/images/linkedin.svg').default} />
              </div>
            </a>
          </div>
          <div className="d-flex flex-column justify-content-center">
            <div className={s.name}>
              {secondTutor.name}
            </div>
            <div className={s.title}>
              {secondTutor.title}
            </div>
          </div>

        </div>
      }


      <div className={s.divider} />
      <div className={s.text} dangerouslySetInnerHTML={{ __html: description }} />


    </div>


  )
}